import { useState, useEffect, useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const NotificationBar = () => {
  const { userData } = useCurrentUser();
  const navigate = useNavigate();
  const { setBannerVisible } = useContext(LayoutContext);

  const [showBanner, setShowBanner] = useState(false);
  // Edits made after submitting are held on the account, so this reads the same
  // on every device.
  const hasUnsentChanges = !!userData?.profileNeedsResubmit;

  useEffect(() => {
    if (
      userData &&
      (userData?.role?.role === "FREELANCER" ||
        userData?.role?.role === "CLIENT" ||
        userData?.role?.role === "CUSTOMER")
    ) {
      // SUBMITTED counts as waiting too: the banner stays up until an admin approves,
      // now reporting that the profile is in review rather than disappearing.
      const isWaiting = ["UNAPPROVE", "PENDING", "SUBMITTED"].includes(userData?.status);

      setBannerVisible(isWaiting);
      setShowBanner(isWaiting);

      /* setBannerVisible(true);
      setShowBanner(true); */
    }
  }, [userData]);

  const isAwaitingReview = userData?.status === "SUBMITTED";
  const needsResubmit = isAwaitingReview && hasUnsentChanges;

  if (!showBanner) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-[50px] z-50 bg-white border-b flex items-center justify-between px-6 ">
      <div className="flex items-center">
        <div className="bg-primary/10 rounded-full w-11 h-11 shrink-0 flex items-center justify-center mr-2">
          <i className="fa-thin fa-user-shield text-primary text-2xl"></i>
        </div>
        <div className="sm:block hidden">
          <h6 className="text-base font-medium !text-primary">
            {needsResubmit
              ? "Resubmit your profile"
              : isAwaitingReview
                ? "Please Wait for Verification"
                : "Complete your account setup"}
          </h6>
          <p>
            {needsResubmit
              ? "You've updated your profile since your last submission. Please resubmit it to complete your account setup."
              : isAwaitingReview
                ? `Your profile is submitted, allow us one-two
            business days for verification.`
                : `Please complete your account information and allow us one-two
            business days for verification.`}
          </p>
        </div>
      </div>

      {/* Still reachable after submitting: the profile stays editable and can be sent again. */}
      <p
        className=" text-primary font-medium cursor-pointer bg-white hover:bg-primary/5 py-2 px-3 rounded-md transition delay-50 duration-300 ease-in-out"
        onClick={() => {
          navigate("/completeYourProfile");
        }}
      >
        {needsResubmit
          ? "Resubmit Profile"
          : isAwaitingReview
            ? "Edit Profile"
            : "Complete Profile"}
      </p>
    </div>
  );
};

export default NotificationBar;
